<div class="close" *ngIf="canClose">
  <button mat-icon-button (click)="closeDialog.emit()" [matTooltip]="closeTooltip ?? ''">
    <fa-icon icon="times"></fa-icon>
  </button>
</div>

<header class="px-3 {{ canClose ? 'pb-3' : 'py-3' }} align-items-{{ headerAlignment }}">
  <x-brand-logo *ngIf="logo"></x-brand-logo>
  <div class="icon mb-2">
    <ng-content select="[xIcon]"></ng-content>
  </div>
  <h3 *ngIf="heading">{{ heading }}</h3>
  <div *ngIf="subheading" class="sub-heading mt-2 mat-body-2" [innerHTML]="subheading"></div>
</header>

<div class="content p-3">
  <ng-content></ng-content>
</div>

<footer class="p-3">
  <ng-content select="x-shop-dialog-actions"></ng-content>
  <ng-content select="x-error-operation, [xError]"></ng-content>
</footer>

<x-loader *ngIf="loading"></x-loader>
